import {
  BristolCityLogo,
  CignaLogo,
  MlbLogo,
  NascarLogo,
  NewYorkKnicksLogo,
  SeattleSoundersFcLogo,
  StravaLogo,
  UnimedLogo,
  UniversityOfVirginiaLogo,
  UnofficialPharmanutraLogo,
  UsArmyLogo,
  WashingtonSpiritSeekLogo,
  YextLogo,
} from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import type { SVGIconComponent } from 'types/svgr';

import type { LandingPageIntegrationData } from '@/app/components/LandingPage/LandingPageIntegrations/types';

export const customers: LandingPageIntegrationData[] = [
  {
    name: 'Nascar',
    Logo: NascarLogo as SVGIconComponent,
  },
  {
    name: 'MLB',
    Logo: MlbLogo as SVGIconComponent,
  },
  {
    name: 'New York Knicks',
    Logo: NewYorkKnicksLogo as SVGIconComponent,
  },
  {
    name: 'Bristol City',
    Logo: BristolCityLogo as SVGIconComponent,
    logoClassName: 'md:w-24',
  },
  {
    name: 'Seattle Sounders FC',
    Logo: SeattleSoundersFcLogo as SVGIconComponent,
  },
  {
    name: 'Strava',
    Logo: StravaLogo as SVGIconComponent,
  },
  {
    name: 'Yext',
    Logo: YextLogo as SVGIconComponent,
  },
  {
    name: 'Washington Spirit',
    Logo: WashingtonSpiritSeekLogo as SVGIconComponent,
  },
  {
    name: 'US Army',
    Logo: UsArmyLogo as SVGIconComponent,
  },
  {
    name: 'Unimed',
    Logo: UnimedLogo as SVGIconComponent,
  },
  {
    name: 'Pharmanutra',
    Logo: UnofficialPharmanutraLogo as SVGIconComponent,
    logoClassName: 'md:w-64',
  },
  {
    name: 'Cigna',
    Logo: CignaLogo as SVGIconComponent,
  },
  {
    name: 'University of Virginia',
    Logo: UniversityOfVirginiaLogo as SVGIconComponent,
  },
].map((integration) => ({
  ...integration,
  logoClassName: cx('sm:h-16 md:h-auto', integration.logoClassName),
}));
